import { filter } from 'lodash';

import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { Mask } from '@core/app/scripts/services/mask';
import { TimeKeeper } from '@core/app/scripts/services/time-keeper';

/*
 * Component responsible for /fiscal-eos route.
 */
angular
  .module('posApp')
  .directive(
    'fiscalEos',
    (
      $q: ng.IQService,
      translate,
      displayMessage: DisplayMessage,
      mask: Mask,
      moment,
      reprintReceipt,
      retailTransactions,
      sales,
      timeKeeper: TimeKeeper,
      salesCalculations,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./fiscal-eos.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate,
          date = timeKeeper.getLocalDate();

        function loadTransactions() {
          return retailTransactions
            .filter({
              startDate: moment(date).startOf('day').format(),
              endDate: moment(date).endOf('day').format(),
            })
            .then((response) => {
              if (response && response.length) {
                $scope.transactions = filter(
                  response,
                  (transaction) => transaction.fiscal_receipt_nr === undefined,
                );
              } else {
                return $q.reject('failed to reload transactions');
              }
            });
        }

        loadTransactions();

        $scope.printReceipt = (partialTransaction) => {
          displayMessage.showLoading();

          return sales
            .get(partialTransaction?._id)
            .then((transaction) => {
              return reprintReceipt(transaction);
            })
            .then(loadTransactions)
            .then(
              () => {
                mask.hide();
              },
              () => {
                mask.hide();
                displayMessage.message(
                  $translate.instant('PrintingNotPossible'),
                );
              },
            );
        };

        $scope.getTransactionTotal = (transaction) => {
          return salesCalculations.total(transaction);
        };
      },
    }),
  );
